export enum UserContext {
  Agency = "agency",
  Customer = "customer",
  Biztrip = "biztrip",
}
